export function capitalize() {
    const string = String(this || '');
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
//# sourceMappingURL=capitalize.js.map